import I18n from 'app/i18n';

interface OtherItemNameProps {
    title: string;
    langs?: {[key: string]: string};
}

export const otherItemName = (artifact: OtherItemNameProps): string => {
    const {langs, title} = artifact;

    return langs && langs[I18n.locale] || title;
};
